import * as Case from 'case';
import {ResponsiveImageComponent} from '~contentful/components/responsive-image/responsive-image.component';
import {ComponentModel} from '~contentful/models/components/component.model';
import {ImageModel} from '~contentful/models/components/image.model';
import {ActionModel} from '~contentful/models/actions/action.model';

export class ResponsiveImageModel extends ComponentModel {
    public readonly name: string;
    public readonly onClick?: ActionModel;
    public readonly desktopImage: ImageModel;
    public readonly tabletImage: ImageModel;
    public readonly mobileImage: ImageModel;
    public readonly componentClass = ResponsiveImageComponent;

    public get contextLabel() {
        return this.name;
    }

    public get contextValue() {
        return Case.kebab(this.name);
    }
}
